export const CONECTIVIDAD = {
    INTERFACES_MARCA: {
        MODAL_EQ_FILE: {
            urlGetInterfaceHistory: 'Services/General/InterfacesMaintenanceService.svc/FindInterfacesHistory',
            urlGetPendingDocumentsIntegrationEQ0093: 'Services/Brand/PartsOrderService.svc/GetPendingDocumentsIntegrationEQ0093',
            urlGetSupplierOrderStates: "Services/WareHouse/OrderSupplierService.svc/GetSupplierOrderStates",
            urlIntegrateDocumentsEQ0093: "Services/Brand/PartsOrderService.svc/IntegrateDocumentsEQ0093",
            urlGetEQ0093DocConfiguration: "/Services/Brand/PartsOrderService.svc/GetEQ0093DocConfiguration"
        },
        MODAL_CSBS_FILE: {
            urlOrdersExportablesServiceBox: "Services/Brand/MaterialSuppliesService.svc/GetOrdersExportablesServiceBox",
            urlExportOrdersServiceBox: "Services/Brand/MaterialSuppliesService.svc/ExportOrdersServiceBox"
        }
    }
}
